import { FaRegCopy, FaRegUser, FaRegUserCircle, FaRegListAlt, FaTasks, FaRegChartBar } from 'react-icons/fa';

const operatorMenuItems = [
  {
    label: 'Шаблони за Документи',
    icon: FaRegCopy,
    ariaLabel: 'document templates',
    to: '/document-templates',
    // childrenRoutes: [
    //   {
    //     label: 'Управление на документите',
    //     icon: FaRegFile,
    //     to: '/document-templates',
    //   },
    //   {
    //     label: 'Пакети с документи',
    //     icon: FaRegFile,
    //     to: '/documents-packages',
    //   },
    // ],
  },
  {
    label: 'Оператори',
    icon: FaRegUser,
    to: '/users',
  },
  {
    label: 'Клиенти',
    icon: FaRegUserCircle,
    to: '/clients',
  },
  {
    label: 'Полета',
    icon: FaRegListAlt,
    to: '/fields',
  },
  {
    label: 'Сегменти',
    icon: FaTasks,
    to: '/segments',
  },
  {
    label: 'Справка потребители',
    icon: FaRegChartBar,
    to: '/reports/usage',
  },
];

export default operatorMenuItems;
